module.exports = __webpack_public_path__ + "static/img/phone1.7e852036.png";